import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUsers } from '../actions/userActions';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

const UsersList = ({ onEdit, onDelete }) => {
  const dispatch = useDispatch();
  const users = useSelector((state) => state.users.users);

  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  return (
    <TableContainer component={Paper}>
      <Table aria-label="users table">
        <TableHead>
          <TableRow>
            <TableCell>ID Utilizator</TableCell>
            <TableCell>Nume</TableCell>
            <TableCell>E-mail</TableCell>
            <TableCell>Rol</TableCell>
            <TableCell>Grupuri Asignate</TableCell>
            <TableCell>Acțiuni</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((user) => (
            <TableRow key={user.user_id}>
              <TableCell>{user.user_id}</TableCell>
              <TableCell>{user.name}</TableCell>
              <TableCell>{user.email}</TableCell>
              <TableCell>{user.role_name || user.role_id}</TableCell>
              <TableCell>
                {user.groups && user.groups.length > 0 ? (
                  <List dense>
                    {user.groups.map((group) => (
                      <ListItem key={group.group_id}>
                        <ListItemText primary={group.group_name} />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  'Fără grupuri asignate'
                )}
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => onEdit(user)}
                  style={{ marginRight: '8px' }}
                >
                  Editează
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => onDelete(user.user_id)}
                >
                  Șterge
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UsersList;
